export const PERMUTIVE_PROJECT_ID = '15f2ad6b-419e-4fad-afad-a5597d0617ca';
export const PERMUTIVE_API_KEY = '511bd62b-c90f-4f0b-af6c-6eabbb716810';
export const PERMUTIVE_NAMESPACE = 'apttherapy';
